<app-manage-template [title]="'Manage Business'"  [COLUMNFIELDS]="columns"
[userData]="(userDatas | async)" [parentData]="businessNetworkDetails" [KEY]="'B2B_CONTACTS'" [content]="'MANAGE_BUSINESS_CONTACTS'"
(updateParent)="updateBusinessNetwork($event)" [dropdownContext]="filterData"
(updateMembers)="updateContactMembers($event)" [onSearch]="onSearch" [holder]="'Search by business name or email'"
[onFilter]="onFilter" [this]="this" [onScroll]="onScroll">

<div class="row mt-1">
  <app-plan-card [cards]="allocationCards" [TOTAL]="PLANMAX"></app-plan-card>

</div>


</app-manage-template>

